
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useLayoutEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useIsOverflowX = function useIsOverflowX(overflowRef) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflow = _useState2[0],
    setIsOverflow = _useState2[1];
  useLayoutEffect(function () {
    var el = overflowRef.current;
    var trigger = function trigger() {
      setIsOverflow(el.offsetWidth < el.scrollWidth);
    };
    if (el) {
      if ("ResizeObserver" in window) {
        new ResizeObserver(trigger).observe(el);
      }
      trigger();
    }
  }, [overflowRef]);
  return isOverflow;
};

export { useIsOverflowX };
//# sourceMappingURL=helpers.js.map
